import * as Yup from 'yup';
import strings from '../../../localization';

import { formikRequired } from '../SoftwareList/validator';

const Validator = () =>
  Yup.object().shape({
    name: formikRequired,
    imageName: Yup.string().required(strings.requiredField),
  });

export default Validator;
